import * as endpoints from './endpoints';
import { fetchPatientFile } from './actions/fetchPatientFile';

const PatientFileService = { ...endpoints, fetchPatientFile };

export default PatientFileService;
export type { PatientFile } from './actions/fetchPatientFile';
